// document.addEventListener("DOMContentLoaded", function () {
//   const navList = document.querySelector('.header__inline-menu ul.list-menu');
//   const currentPath = window.location.pathname;

//   if (!navList) return;

//   // 1️⃣ Create Gemstone menu item
//   const newMenuItem = document.createElement('li');
//   newMenuItem.className = 'header__mega-menu-wrapper';

//   newMenuItem.innerHTML = `
//     <a href="#" class="header__menu-item list-menu__item link link--text focus-inset zyx-menu-toggle">
//       <span>Gemstones</span>
//     </a>
//     <div class="header__mega-menu">
//       <div class="row">
//         <div class="col-md-7 col-12" id="shopMenuCol1">
//              <h2 class="pb-4">Shop Gemstones by Type</h2>
//         </div>
//  <div class="col-md-5 col-12">
//   <div class="mega-banner">
//     <img src="https://cdn.shopify.com/s/files/1/0639/1057/6287/files/ChatGPT_Image_Mar_26_2026_11_09_18_AM.png?v=1774503588" alt="banner">
//   </div>
// </div>

//       </div>
//     </div>
//   `;

//   // Insert Gemstone first
//   navList.insertBefore(newMenuItem, navList.firstChild);

//   const toggleLink = newMenuItem.querySelector('.zyx-menu-toggle');
//   const megaMenu = newMenuItem.querySelector('.header__mega-menu');

//   // 2️⃣ Toggle mega menu
//   toggleLink.addEventListener('click', function (e) {
//     e.preventDefault();
//     megaMenu.classList.toggle('open');
//   });

//   // Close when clicking outside
//   document.addEventListener('click', function (e) {
//     if (!newMenuItem.contains(e.target)) {
//       megaMenu.classList.remove('open');
//     }
//   });

//   // 3️⃣ Populate mega menu cards from Shopify 'shop-menu'
//   const rawItems = document.querySelectorAll("#shopMenuRaw li");
//   const col1 = document.getElementById("shopMenuCol1");
//   const banner = document.querySelector("#menuBanner img");

//   const itemConfig = {
//     "Yellow Sapphire": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Yellow_Sapphire.png?v=1756124160",
//       banner: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Frame_3867_1.avif?v=1755764862"
//     },
//     "Blue Sapphire": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Blue_Sapphire.png?v=1756125333",
//     },
//     "Pink Sapphire": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Pink_Sapphire.png?v=1756125523",
//     },
//     "Emerald": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Emerald.png?v=1756125541",
//     },
//     "Ruby": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Ruby_8c43027e-4d89-43d7-973f-6833da0030c9.png?v=1756125557",
//     },
//     "White Sapphire": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/White_Sapphire.png?v=1756125577",
//     },
//     "Turquoise": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Turquoise.png?v=1756125598",
//     },
//     "Opal": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Opal.png?v=1768211079",
//     },

//      "Coral": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Coral.png?v=1756125705",
//     },

//      "Pitambari": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Curiosities_and_Bi-Color_Sapphires.png?v=1756125727",
//     },

//     "Pearl": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Pearl_9878faf8-e5dc-43b3-be90-29973b367968.png?v=1756125840",
//     },


//      "Hassonite": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/2_780ce518-db52-4148-b745-c7c912d19bf6.png?v=1768223412",
//     },

//     "Hassonite": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/2_780ce518-db52-4148-b745-c7c912d19bf6.png?v=1768223412",
//     },

//     "Hassonite": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/2_780ce518-db52-4148-b745-c7c912d19bf6.png?v=1768223412",
//     },

//     "Cats Eye": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/cats-eyes-28052025-020126_c786c7af-d43f-4a0d-a82b-9262bce2593f.webp?v=1770705065",
//     },


//      "Thai Sapphire": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Layer_2.png?v=1772002983",
//     },

//       "Burma Rubies": {
//       icon: "https://cdn.shopify.com/s/files/1/0639/1057/6287/files/Burma_Ruby.png?v=1770893973",
//     },


//   };

//   const cards = [];

//   rawItems.forEach((li) => {
//     const title = li.dataset.title.trim();
//     const url = li.dataset.url;
//     const config = itemConfig[title] || {};

//     const icon = config.icon || "{{ 'placeholder.png' | asset_url }}";

//     const card = document.createElement("div");
//     card.className = "menu-card mb-3";
//     card.dataset.url = url;

//     card.innerHTML = `
//      <a href="${url}" class="menu-title">
//     <div class="menu-img">
//         <img src="${icon}" alt="${title}">
//       </div>
//       <div class="menu-text">
//         <a href="${url}" class="menu-title">${title}</a>
//       </div>
//       </a>
//     `;

//     // Hover → change banner
//     card.addEventListener("mouseenter", () => {
//       if (banner && config.banner) banner.src = config.banner;
//     });

//     // Click → active state
//     card.addEventListener("click", () => {
//       cards.forEach(c => c.classList.remove("active"));
//       card.classList.add("active");
//     });

//     cards.push(card);
//     col1.appendChild(card); // All items in col1 (change logic to split if needed)
//   });

//   // Set active card on page load
//   cards.forEach(card => {
//     if (currentPath === card.dataset.url || currentPath.startsWith(card.dataset.url)) {
//       card.classList.add("active");
//       const title = card.querySelector(".menu-title").textContent;
//       if (itemConfig[title] && banner) banner.src = itemConfig[title].banner;
//     }
//   });
// });


// ----------- PDP cutom -------

document.addEventListener("DOMContentLoaded",()=>{const a=document.getElementById("openCertificateModal");if(a){a.onclick=()=>{var m=new bootstrap.Modal(document.getElementById("certificateModal"));m.show();};}});



document.addEventListener("DOMContentLoaded", function () {
  
  const rows = document.querySelectorAll(".spec-table-box tbody tr");
  let index = 0;

  rows.forEach(row => {
    const tds = row.querySelectorAll("td");

    // Skip empty rows if any accidentally generated
    if (tds.length === 0) return;

    index++;

    if (index % 2 === 1) {
      // ODD = white
      tds.forEach(td => td.style.backgroundColor = "#ffffff");
    } else {
      // EVEN = grey
      tds.forEach(td => td.style.backgroundColor = "#f7f7f7");
    }
  });

});



// ----- LINK's update  ------

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("p").forEach((p) => {
    const txt = (p.textContent || "").trim();

    // Shipping Policy
    if (txt.includes("Shipping policy") && txt.includes("Learn more")) {
      p.innerHTML = p.innerHTML.replace(
        /Learn more/g,
        '<a href="/policies/shipping-policy" class="policy-link">Learn more</a>'
      );
    }

    // Return Policy
    if (txt.includes("Return policy") && txt.includes("Learn more")) {
      p.innerHTML = p.innerHTML.replace(
        /Learn more/g,
        '<a href="/policies/refund-policy" class="policy-link">Learn more</a>'
      );
    }
  });
});



// -------- Shop ke need help -------

document.addEventListener("DOMContentLoaded", function () {

  // Find all footer menu blocks
  const footerMenus = document.querySelectorAll(".footer-block--menu");

  footerMenus.forEach(function(block) {
    const heading = block.querySelector(".footer-block__heading");

    // Check heading text = Shop
    if (heading && heading.textContent.trim().toLowerCase() === "our stores") {

      // Avoid duplicate insertion
      if (block.querySelector(".need-help-info")) return;

      // Create help box
      const helpBox = document.createElement("div");
      helpBox.className = "need-help-info";
      helpBox.innerHTML = `

       

        <div class="accordion" id="accordionExample">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        The Jwels
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div class="accordion-body">
          <a href="https://maps.app.goo.gl/eGZSKzF9FbEB5J4Y8" target="_blank">2nd Floor, A-285, Bhishma Pitamah Marg, Block A, Defence Colony, New Delhi – 110003</a><br>

          <a href="">info@thejwels.com</a> <br>

           <a href="tel:+918595531466" class="text-decoration-none">+91 85955 31466</a> |
            <a href="tel:+919899092595" class="text-decoration-none">+91 98990 92595</a> |
            <a href="tel:+919899170004" class=" text-decoration-none">+91 98991 70004</a>
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
        Sethi Gems
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div class="accordion-body">
       <a href="https://maps.app.goo.gl/nFxnsGNjMU9xmbaM8"
             target="_blank">2503/8, 1st Floor, Beadonpura, Gurudwara Road Karol Bagh,
            8 No: Beadon Pura, Karol Bagh, Delhi-110005</a> <br>

            <a href="mailto:sethigems@gmail.com">sethigems@gmail.com</a><br>

             <a href="tel:+919625831466" class="text-decoration-none">+91 96258 31466</a> |
            <a href="tel:+919312231466" class="text-decoration-none">+91 93122 31466</a> |
            <a href="tel:+919899092595" class="text-decoration-none">+91 98990 92595</a>
      </div>
    </div>
  </div>
 
</div>
         
      `;

      // Insert after the Shop menu list
      const menuList = block.querySelector("ul");
      if (menuList) {
        menuList.after(helpBox);
      }
    }
  });

});


// ------- price filter -------------
document.addEventListener("DOMContentLoaded", () => {
  const wraps = document.querySelectorAll(".facet-range");

  const debounce = (fn, wait = 400) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  };

  wraps.forEach((wrap) => {
    const slider = wrap.querySelector(".facet-range__slider");
    const track = wrap.querySelector(".facet-range__track");

    const minR = wrap.querySelector('[data-role="min"]');
    const maxR = wrap.querySelector('[data-role="max"]');

    const minI = wrap.querySelector('[data-role="min-input"]');
    const maxI = wrap.querySelector('[data-role="max-input"]');

    if (!slider || !track || !minR || !maxR || !minI || !maxI) return;

    const minLimit = parseFloat(slider.dataset.min || "0");
    const maxLimit = parseFloat(slider.dataset.max || "100");
    const step = parseFloat(slider.dataset.step || "1");

    const clamp = (v) => Math.min(maxLimit, Math.max(minLimit, v));
    const roundStep = (v) => Math.round(v / step) * step;

    const paint = () => {
      const minV = parseFloat(minR.value);
      const maxV = parseFloat(maxR.value);
      const minP = ((minV - minLimit) / (maxLimit - minLimit)) * 100;
      const maxP = ((maxV - minLimit) / (maxLimit - minLimit)) * 100;
      track.style.setProperty("--min-p", `${minP}%`);
      track.style.setProperty("--max-p", `${maxP}%`);
    };

    const syncFromRanges = () => {
      let a = clamp(parseFloat(minR.value));
      let b = clamp(parseFloat(maxR.value));

      if (a > b - step) a = b - step;

      a = roundStep(a);
      b = roundStep(b);

      minR.value = a;
      maxR.value = b;
      minI.value = a;
      maxI.value = b;
      paint();
    };

    const syncFromInputs = () => {
      let a = clamp(parseFloat(minI.value || String(minLimit)));
      let b = clamp(parseFloat(maxI.value || String(maxLimit)));

      if (a > b - step) a = b - step;

      a = roundStep(a);
      b = roundStep(b);

      minI.value = a;
      maxI.value = b;
      minR.value = a;
      maxR.value = b;
      paint();
    };

    const applyFilters = debounce(() => {
      // Dawn-like themes listen to input events on named inputs
      minI.dispatchEvent(new Event("input", { bubbles: true }));
      maxI.dispatchEvent(new Event("input", { bubbles: true }));
    }, 450);

    // init
    syncFromRanges();

    // slider dragging
    minR.addEventListener("input", () => { syncFromRanges(); });
    maxR.addEventListener("input", () => { syncFromRanges(); });

    // apply when user releases (change)
    minR.addEventListener("change", () => { syncFromRanges(); applyFilters(); });
    maxR.addEventListener("change", () => { syncFromRanges(); applyFilters(); });

    // manual numbers
    minI.addEventListener("change", () => { syncFromInputs(); applyFilters(); });
    maxI.addEventListener("change", () => { syncFromInputs(); applyFilters(); });
  });
});

// -- jewlery button click  button -----


// document.addEventListener("click", function (e) {
//   const btn = e.target.closest('.whatsapp-btn');
//   if (!btn) return;

//   e.preventDefault();

//   const number = btn.dataset.number;
//   const title = btn.dataset.title;
//   const url = btn.dataset.url;

//   const message = `Hi, I am interested in ${title} ${url}`;
//   const whatsappUrl = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

//   window.open(whatsappUrl, '_blank');
// });


document.addEventListener('DOMContentLoaded', function() {

  function openBookingModal(e) {
    e.preventDefault();

    const modal = document.getElementById('bookingModal');

    if (modal) {
      modal.style.display = 'block';
      modal.classList.add('show');
      document.body.classList.add('modal-open');
    }
  }

  // Menu link
  document.getElementById('menu-link-6')?.addEventListener('click', openBookingModal);

  // All CTA Details
  document.querySelectorAll('.cta-detail').forEach(function(item) {
    item.addEventListener('click', openBookingModal);
  });

  // Close button
  document.querySelector('#bookingModal .btn-close')?.addEventListener('click', function() {
    const modal = document.getElementById('bookingModal');

    modal.style.display = 'none';
    modal.classList.remove('show');
    document.body.classList.remove('modal-open');
  });

});



  // document.getElementById('menu-link-6').addEventListener('click', function(e) {
  //   e.preventDefault();
  //   var modal = document.getElementById('bookingModal');
  //   if (modal) {
  //     modal.style.display = 'block';
  //     modal.classList.add('show');
  //     document.body.classList.add('modal-open');
  //   }
  // });

  // document.querySelector('#bookingModal .btn-close').addEventListener('click', function() {
  //   var modal = document.getElementById('bookingModal');
  //   modal.style.display = 'none';
  //   modal.classList.remove('show');
  //   document.body.classList.remove('modal-open');
  // });
